import styled from '@emotion/styled'
import { ChecTooltip } from 'components/chec'
import { HoverableInfoIcon } from 'components/patterns'
import { stylesIf, themeColor } from 'utils/styles'

export const PartDescription = styled(ChecTooltip)`
  width: 295px;
  cursor: pointer;
`

export const MsfHeader = styled.span((props) => {
  const { paragraphColor } = props.theme.color

  return `
  color: ${paragraphColor};
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin: 0;
  padding: 0;
  align-self: center;
  margin-right: 4px;
  `
})

export const PanelName = styled.span((props) => {
  const { paragraphColor } = props.theme.color

  return `
  color: ${paragraphColor};
  font-size: 12px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin: 0;
  padding: 0;
  align-self: center;
  `
})

export const ComponentList = styled.div((props) => {
  const { index } = props

  return `
      ${stylesIf(
        index > 0,
        `border-top: 1px solid ${themeColor('grey', props)};`
      )}
      padding: 5px 0;
    `
})

export const SecondaryHeaderContainer = styled.div`
  display: flex;
  margin-top: 15px;
`
export const StyledHoverableInfoIcon = styled(HoverableInfoIcon)`
  position: relative;
  top: -6px;
`

export const StagingList = styled.div((props) => {
  const { theme } = props

  return `
    border-top: 1px solid ${theme.color.grey};
    margin: 15px 0;
  `
})

export const SubHeaderContainer = styled.div`
  display: flex;
`
export const DragIcon = styled.div`
  margin-left: 5px;
  margin-top: 4px;
  display: inline-flex;
`
